export default __webpack_public_path__ + "static/media/C.0d238133.svg";